/**
 * Add this to an error message to prevent it from being sent to Sentry.
 */
export const SentryIgnoredError = '[SentryIgnoredError]';
